import { useState } from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";

//APP
import { STATUS_EM_ANALISE } from "../../meta";
import { loadingAlert, successAlert, infoAlert, destroyAlert } from "../../../../../../../../utils/alert";
import type { OsItensTypes } from "../../../../../../../../services/OsParaColeta/GET";

//COMPONENTS
import ButtonCustom from "../../../../../../../../Components/ButtonCustom";

//PROPS
interface Props {
    /** cod da OS desta linha — usado para achá-la na lista recarregada. */
    cod: number;
    /** `refetch` do react-query: devolve a lista recarregada. */
    refetch: () => Promise<{ data?: { itens?: OsItensTypes[] } } | unknown> | void;
}

/**
 * Botão de checagem manual do processamento da análise.
 *
 * Depois do upload o backend processa o arquivo e muda o status sozinho
 * (5 a 30 segundos), mas não avisa o front — não há sistema de notificação.
 * Até existir, o usuário confere no clique em vez de esperar às cegas.
 */
export const ChecarProcessamento: React.FC<Props> = ({ cod, refetch }) => {

    //#region STATES
    const [checando, setChecando] = useState<boolean>(false);

    async function checar() {
        setChecando(true);
        loadingAlert({ msg: 'Checando...', id: 'checar-processamento' });

        try {
            const resultado: any = await refetch();

            // O status é lido da lista recém-carregada, não da prop da linha: a
            // prop só é atualizada no re-render, depois deste callback terminar.
            const os = (resultado?.data?.itens ?? []).find((item: OsItensTypes) => item?.cod === cod);

            // O loading é fechado aqui, e não pelo 3º argumento dos alerts: o
            // `infoAlert` reaproveita esse id como `toastId` do toast novo, e o
            // react-toastify descarta como duplicado o que nasce com o id que
            // acabou de ser removido — o toast de info simplesmente não aparecia.
            destroyAlert('checar-processamento');

            if (os && os.status !== STATUS_EM_ANALISE) {
                successAlert('Processamento foi concluído!', 5000);
            } else {
                infoAlert('Análise ainda em processamento!', 5000);
            }
        } finally {
            setChecando(false);
        }
    };

    return (
        <Tooltip title='Checar se o processamento foi concluído' placement='bottom'>
            <span style={{ display: 'inline-flex' }}>
                <ButtonCustom
                    type='tertiary'
                    onClick={checar}
                    loading={checando}
                    icon={<FontAwesomeIcon icon={faRotate} />}
                />
            </span>
        </Tooltip>
    );
}
